/**
 * 危化品模块子路由
 * 路径均为相对路径，根路由会以 /chemical 为前缀挂载
 */

// 危化品子路由数组
export const chemicalRoutes = [
  {
    path: 'inventory',
    name: 'ChemicalInventory',
    component: () => import('@/modules/chemical/views/inventory/index.vue'),
    meta: { title: '库存' }
  },
  {
    path: 'purchase',
    name: 'ChemicalPurchase',
    component: () => import('@/modules/chemical/views/purchase/index.vue'),
    meta: { title: '采购' }
  },
  {
    path: 'inbound',
    name: 'ChemicalInbound',
    component: () => import('@/modules/chemical/views/inbound/index.vue'),
    meta: { title: '入库' }
  },
  {
    path: 'get',
    name: 'ChemicalGet',
    component: () => import('@/modules/chemical/views/get/index.vue'),
    meta: { title: '领取' }
  },
  {
    path: 'outbound',
    name: 'ChemicalOutbound',
    component: () => import('@/modules/chemical/views/outbound/index.vue'),
    meta: { title: '出库' }
  },
  {
    path: 'use',
    name: 'ChemicalUse',
    component: () => import('@/modules/chemical/views/used/index.vue'),
    meta: { title: '使用' }
  },
  {
    path: 'record',
    name: 'ChemicalRecord',
    component: () => import('@/modules/chemical/views/record/index.vue'),
    meta: { title: '台账' }
  },
  {
    path: 'internet',
    name: 'ChemicalInternet',
    component: () => import('@/modules/chemical/views/internet/index.vue'),
    meta: { title: '物联网', theme: 'dark' }
  },
  {
    path: 'profile',
    name: 'ChemicalProfile',
    component: () => import('@/modules/chemical/views/profile/index.vue'),
    meta: { title: '个人中心' }
  },
  {
    path: 'example',
    name: 'ChemicalExample',
    component: () => import('@/modules/chemical/views/example/index.vue'),
    meta: { title: '示例' }
  }
]

export default chemicalRoutes
